// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referral-details-view .ui-base-card-header__children{overflow:hidden}.referral-details-view .ui-base-card-header__children div:last-child{max-width:600px}", ""]);
// Exports
module.exports = exports;
